module.exports = __webpack_public_path__ + "static/media/safeway.0b1d73a0.svg";